import React from 'react';

import buttonLeft from "../assets/images/tetris/left.png";
import buttonRight from "../assets/images/tetris/right.png";
import buttonUp from "../assets/images/tetris/up.png";
import buttonDown from "../assets/images/tetris/down.png";

import useScreenOrientation from './helpers/useScreenOrientation';

export default function Instructions({ isVisible, setView, isGameLoaded, setPlayGame}: any) {

  const isLandscape = useScreenOrientation();

  return (
    <div className={`full-instructions-container ${isVisible === true ? 'active' : 'hidden'}`}>
      
      <div className={`instructions-container ${isLandscape ? '' : 'portrait'}`}>
        
        <div className={`instructions-title ${isLandscape ? '' : 'portrait'}`}>Instrucciones</div>

        <div className={`instructions-content ${isLandscape ? '' : 'portrait'}`}>
          <div className={`instructions-content-desc ${isLandscape ? '' : 'portrait'}`}>
            Mueve y gira los bloques que caen desde arriba para encajarlos y formar líneas horizontales completas. Al completar una línea, desaparece y ganas puntos.
          </div>
          <div className={`instructions-content-buttons ${isLandscape ? '' : 'portrait'}`}>

            <div className={`instructions-content-left ${isLandscape ? '' : 'portrait'}`}>
              <img className={`instructions-content-key ${isLandscape ? '' : 'portrait'}`} src={buttonLeft} alt=''/>
              <img className={`instructions-content-key ${isLandscape ? '' : 'portrait'}`} src={buttonRight} alt=''/>
            </div>
            <div className={`instructions-content-right ${isLandscape ? '' : 'portrait'}`}>
              <div className={`instructions-content-text ${isLandscape ? '' : 'portrait'}`}>Mover ficha</div>  
            </div>

            <div className={`instructions-content-left ${isLandscape ? '' : 'portrait'}`}>
              <img className={`instructions-content-key ${isLandscape ? '' : 'portrait'}`} src={buttonUp} alt=''/>
            </div>
            <div className={`instructions-content-right ${isLandscape ? '' : 'portrait'}`}>
              <div className={`instructions-content-text ${isLandscape ? '' : 'portrait'}`}>Rotar ficha</div>  
            </div>

            <div className={`instructions-content-left ${isLandscape ? '' : 'portrait'}`}>
              <img className={`instructions-content-key ${isLandscape ? '' : 'portrait'}`} src={buttonDown} alt=''/>
            </div>
            <div className={`instructions-content-right ${isLandscape ? '' : 'portrait'}`}>
              <div className={`instructions-content-text ${isLandscape ? '' : 'portrait'}`}>Bajar ficha</div>  
            </div>

          </div>
          <div className={`instructions-content-desc ${isLandscape ? '' : 'portrait'}`}>
            Puedes usar las flechas de tu teclado, o los controles en la pantalla para mover los bloques.
          </div>
        </div>
        
        <div className={`instructions-send-button ${(isGameLoaded) ? '' : 'error'}`} onClick={() => { if (isGameLoaded === true) {setView("SceneUI"); setPlayGame(true)} }}>
          <div className={`instructions-send-button-text ${isLandscape ? '' : 'portrait'}`}>{isGameLoaded ? `Continuar` : `Cargando`}</div>
        </div>

      </div>

    </div>
  );
}